import React, { useEffect, useState } from "react";
import { callApi } from "../../utils/api";
import { toast } from "react-toastify";
import isEmpty from 'lodash/isEmpty';

export default function AlertSlotSettings() {
    const [slots, setSlots] = useState<string>("");
    const [message, setMessage] = useState<string>("");

    // Load slots & message from backend
    useEffect(() => {
        callApi("GET", "get_shift_alert_slots.php")
            .then(async ({ data: { result, slots, message } }) => {
                if (result) {
                    if (slots) setSlots(slots.join(","));
                    if (message) setMessage(message);
                }
            })
            .catch((err) => console.error("Error loading slots:", err));
    }, []);

    const handleSave = () => {
        const slotArray = slots
            .split(",")
            .map((s) => parseInt(s.trim(), 10))
            .filter((n) => !isNaN(n));
        if (!isEmpty(slots) && !isEmpty(message)) {
            callApi("POST", "save_shift_alert_slots.php", { slots: slotArray, message })
                .then(async ({ data: { result, message: msg } }) => {
                    if (result) {
                        toast.success(msg, { autoClose: 3000 });
                    } else {
                        toast.error(msg, { autoClose: 3000 });
                    }
                })
                .catch((err) => console.error("Save error:", err));
        } else {
            toast.error("Enter slot and message", { autoClose: 3000 });
        }
    };

    return (
        <div className="p-3 row">
            <div className="col-md-6">
                <div className="form-group">
                    <label>Configure Alert Slots (minutes before shift end)</label>
                    <input
                        type="text"
                        className="form-control mb-2"
                        value={slots}
                        placeholder="e.g. 60,30,15,5,2"
                        onChange={(e) => setSlots(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>Alert Message</label>
                    <textarea
                        className="form-control mb-2"
                        rows={3}
                        placeholder="Enter custom alert message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </div>
                <button className="btn btn-primary" onClick={handleSave}>
                    Save Settings
                </button>
            </div>
        </div>
    );
}
